<!-- компонент для рисования тарифов в SSL -->
<template><div>
	<!-- селектор фильтра -->
	<div v-if="groups && groups.length > 1" class="w5-vds-plan-list-filter-wrapper plan">
		<span v-for="(group, gIdx) in groups"
			class="w5-vds-plan-list-filter"
			:key="'group-' + gIdx"
			:class="{ 'first': gIdx === 0, 'last': gIdx === (groups.length - 1), 'active': String(curGroup) === String(group.id) }"
			@click.prevent.stop="onGroupClick(group.id)">{{ group.name }}</span>
		<div class="description">{{ groupDescription() }}</div>
	</div>
	<div v-else class="margin-top-5"></div>

	<div v-if="items && items.length" class="w5-ssl-plan-list-block">
		<div v-for="(item, prop, idx) in mainList" 
			class="w5-ssl-plan-list-item"
			:key="'item-' + idx"
			:class="{ 'selected': isItemSelected(prop), 'first': idx === 0 }"
			@click="onItemClick(item, $event)">
			
				<div class="w5-ssl-plan-list-item-cell middle">
					
					<strong>{{ prop }}</strong>
					<br class="visible-xs" />
					<span class="ssl-prop-wrapper">
						&nbsp; 
						<span class="ssl-prop" :class="!item['data'] || !item['data']['EV'] ? 'disabled' : false"><font-awesome-icon icon="lock" /> EV</span>
						&nbsp; 
						<span class="ssl-prop" :class="!item['data'] || !item['data']['Wildcard'] ? 'disabled' : false"><font-awesome-icon icon="globe-americas" /> Wildcard</span>
					</span>
					
					<br>
					<p>{{ item['description'] }}</p>

					<div class="w5-ssl-plan-list-item-cell bottom visible-xs">
						<div v-for="(price, prp, pix) in item.price"
							class="price-wrapper"
							:key="'price-visible-xs-' + pix"
							:class="{ 'first': pix === 0, 'selected': price.id == curValue, 'disabled': !price.enable }"
							@click.stop="onPriceClick(price.id, price.enable)">
							<div class="choice" :class="{ 'selected': price.id == curValue }"><span></span></div>
							<strong>{{ price['cost'] | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span></strong> / {{ price['period_name'] }}
						</div>
					</div>

										
				</div>

				<div class="w5-ssl-plan-list-item-cell right hidden-xs">
					<div v-for="(price, prp, pix) in item.price"
						class="price-wrapper"
						:key="'price-hidden-xs-' + pix"
						:class="{ 'first': pix === 0, 'selected': price.id == curValue, 'disabled': !price.enable }"
						@click.stop="onPriceClick(price.id, price.enable)">
						<div class="choice" :class="{ 'selected': price.id == curValue }"><span></span></div>
						<strong>{{ price['cost'] | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span></strong> / {{ price['period_name'] }}
					</div>
				</div>
			
		</div>
	</div>
</div></template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'planSslComponent',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['items', 'value', 'title', 'required', 'groups', 'groupValue', 'cookieValue'],
	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data() {
		return {
			// текущее значение
			curValue: null,
			// основной список - группировка по названию
			mainList: {}
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// установим значение группы
		this.curGroup = this.groupValue
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// текущее описание группы
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		groupDescription() {
			let desc = ''
			if (this.groups && this.groups.length)
			{
				this.groups.some(group => {
					if (String(this.curGroup) === String(group.id))
					{
						desc = group.description
						return true
					}
				})
			}

			return desc
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// клик по тарифу
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onGroupClick(id) {
			// эмуляция фокуса
			this.$emit('focus')
			// запоминаем новое значение
			this.curGroup = String(id)
			// сообщаем родителю что у нас поменялось значение
			this.$emit('groupChanged', this.curGroup)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// клик по самому тарифу
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onItemClick(item, event) {
			// эмуляция фокуса
			this.$emit('focus')
			// если что то не то
			if (!item || typeof item !== 'object' || !('price' in item)) return
			// ищем первую доступную цену этого тарифа
			for (let p in item.price)
			{
				if (item.price[p].enable === true)
				{
					// запоминаем новое значение
					this.curValue = String(item.price[p].id)
					// сообщаем родителю что у нас поменялось значение
					this.$emit('input', this.curValue)
					// на это все
					return
				}
			}
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// клик по стоимости тарифа
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onPriceClick(id, enable) {
			// эмуляция фокуса
			this.$emit('focus')
			// если заблокировано
			if (!enable) return
			// запоминаем новое значение
			this.curValue = String(id)
			// сообщаем родителю что у нас поменялось значение
			this.$emit('input', this.curValue)
		},
		isItemSelected(id) {
			if (!Object.keys(this.mainList).length) return false
			for (let p in this.mainList[id]['price'])
			{
				if (String(this.mainList[id]['price'][p]['id']) === String(this.curValue))
					return true
			}

			return false
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// инициализация начального значения и форматирование списка
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		initValue() {
			// форматирование списка
			if (this.items && this.items.length)
			{
				// составим список
				this.items.forEach(item => {
					// если еще нет такого тарифа
					if (!(item.name in this.mainList))
						this.mainList[item.name] = {
							'description': item.description,
							'data': item.data,
							'price': {}
						}

					// теперь нужно добавить цены и период
					let _price = String(item.cost) + '_' + item.period_name.replace(/\s/g, '_')
					this.mainList[item.name]['price'][_price] = {
						'id': item.id,
						'enable': item.enable,
						'min_money': item.min_money,
						'can_bonus': item.can_bonus,
						'cost': item.cost,
						'period_name': item.period_name
					}
				})

				// если указано текущее значение
				if (this.value !== undefined && this.value !== null)
				{
					this.curValue = this.value
					this.$emit('input', this.curValue)
				}

				// если указано значение с сайта
				if (this.cookieValue !== undefined && this.cookieValue !== null)
				{
					this.curValue = String(this.cookieValue)
					this.$emit('input', this.curValue)
				}
			}
			else
			{
				this.curValue = null
				this.$emit('input', this.curValue)
			}
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'value': function(value) {
			this.curValue = String(value)
		},
		// если изменился список - перегрузили его
		'items': function(items, old) {
			// инициализируем, только если список изменился
			if (!Helper.arrayCompare(items, old)) this.initValue()
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-ssl-plan-list-block {
	position: relative;
    margin: 10px 0;
}

.w5-ssl-plan-list-block > .title {
	color: #9e9e9e !important;
	font-size: 70%;
}

.w5-ssl-plan-list-item {
	display: table;
	width: 100%;
	border-radius: 4px;
	margin-top: 4px;
	cursor: pointer;
}

.w5-ssl-plan-list-item.first {
	margin-top: 0;
}


.w5-ssl-plan-list-item-cell {	
	display: table-cell;
	vertical-align: middle;
	padding: 5px 15px;
	border: 1px solid #ddd;
}

.w5-ssl-plan-list-item-cell p {
	font-size: 11px;
	margin-bottom: 0;
}

.w5-ssl-plan-list-item-cell.left {
	width: 6%;
	border-radius: 6px 0 0 6px;
	text-align: center;
}

.w5-ssl-plan-list-item-cell .choice {
	position: relative;
	top: 1px;
	display: inline-block;	
	width: 18px;
	height: 18px;
	line-height: 18px;
	margin-right: 6px;
	border-radius: 9px;
	background: #CDD1DA;
    box-shadow: inset 0 2px 3px rgba(0,0,0,.2);
    transition: all .2s;
}

.w5-ssl-plan-list-item-cell .choice > span {
	position: relative;
	display: inline-block;
	width: 10px;
    height: 10px;
    left: 4px;
    border-radius: 5px;
    background-color: #f6f6f6;
    box-shadow: 0 2px 5px rgba(0,0,0,.3);
    transition: all .2s;
}

.w5-ssl-plan-list-item-cell .choice.selected {
	background-color: #2c8ad8;
}
.w5-application.mc .w5-ssl-plan-list-item-cell .choice.selected {
	background-color: #01196f;
}
.w5-ssl-plan-list-item-cell .choice.selected > span {
	background-color: #fff;
}


.w5-ssl-plan-list-item-cell.middle {
	font-size: 100%;
	width: 70%;
	border-radius: 6px 0 0 6px;
}

.w5-ssl-plan-list-item-cell.right {
	font-size: 100%;
	width: 30%;
	border-radius: 0 6px 6px 0;
	border-left: 0px;
}

.w5-ssl-plan-list-item-cell.bottom {
	font-size: 90%;
	border: none;
}

/*.w5-ssl-plan-list-item:hover .w5-ssl-plan-list-item-cell,*/
.w5-ssl-plan-list-item.selected .w5-ssl-plan-list-item-cell {
	background-color: #dceeff;
	border-color: #3ba3ff;
}

/*.w5-ssl-plan-list-item:hover .w5-ssl-plan-list-item-cell.right,*/
.w5-ssl-plan-list-item.selected .w5-ssl-plan-list-item-cell.right {
	background-color: white;
}

.price-wrapper {
	/*
	border: 1px solid #ddd;
	border-radius: 4px;
	*/
	cursor: pointer;
	padding: 4px 8px;
	margin-top: 4px;
	transition: all .2s;
	background-color: white;
}
.price-wrapper.first {
	margin-top: 0;
}

/*
.price-wrapper:hover,
.price-wrapper.selected {
	border-color: #3ba3ff;
}
*/

.price-wrapper.disabled {
	color: #ccc !important;
}


.ssl-prop-wrapper {
	position: relative;
	top: -2px;	
}

.ssl-prop {
	font-size: 10px;
	font-weight: 500;
	padding: 0 6px;
	border: 1px solid #999;
	border-radius: 4px;
	color: black;
	background-color: white;
}

.ssl-prop svg {
	font-size: 9px;
	color: #41b883;
}

.ssl-prop.disabled {
	color: #ccc;
	border-color: #ccc;
}

.ssl-prop.disabled svg {
	color: #ccc;
}

@media (max-width: 767px) {
	.w5-ssl-plan-list-item-cell.middle {
		width: 90%;
		border-radius: 6px;
		padding: 5px;
	}
	.w5-ssl-plan-list-item-cell.middle > strong,
	.w5-ssl-plan-list-item-cell.middle > p {
		margin-left: 15px;
	}
	.w5-ssl-plan-list-item {
		margin-top: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// planssl.vue?5f022836